import React, { useEffect, useState } from "react";
import BootstrapTable from 'react-bootstrap-table-next';
import Card from "../../shared/Card";
import axios from "axios";
import { Link } from "react-router-dom";
import { InfoCircle } from 'react-bootstrap-icons';

export default function NaicsList(props) {
  const [data, setData] = useState([]);
  const columnDefs = [
    { dataField: 'NAICS_CODE', text: 'NAICS Code', headerAttrs: { hidden: true } },
    { dataField: 'NAICS_DESC', text: 'NAICS Description', sort: true, headerAttrs: { hidden: true } },
  ];
  useEffect(() => {
    axios.get(`api/v1/hwts/search/facility/naics?epaid=${props.EPA_ID}`)
      .then((res) => {
        setData(res.data);
      });
  }, [props.EPA_ID]);

  return (
    <Card
      style={{ width: '18rem' }}
      cardType="default"
      cardColor="white"
      headerColor="#046B99"
      headerTextColor="white"
      cardHeader={<>NAICS Codes
                <Link to="#" style={{ color: '#FFF' }} onClick={(e) => {
          window.open("https://www.census.gov/naics/", "_blank");
          e.preventDefault();
        }}>
          <span style={{ position: "relative", left: "6px", bottom: "4px" }}><InfoCircle /></span>
        </Link>
      </>}
      cardBody={
        <div className="naics-card" style={{ marginTop: 0 }}>
          <BootstrapTable
            bordered={false}
            keyField='NAICS_CODE'
            data={data}
            columns={columnDefs}
          />
        </div>
      }
    />
  );
}
